exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-template table,.table-template table td,.table-template table td div,.table-template table tr{outline:none;text-align:center}.table-template table{width:100%;text-align:center}.table-template table td{min-width:60px}#content{overflow:auto}", ""]);

// exports
